namespace SP {
    export interface OrderInfo {
        orderId: number;
        orderNo: string;
        orderSource: string;
        referenceNo: string;
        customerId: string;
        warehouseNotificationPacker: string;
        warehouseNotificationPicker: string;
        printDeliveryNote: boolean;
        recipient: Address;
        sender: Address;
        //deliveryMethod: string;
        deliveryMethod: string;
        state: OrderState;
        note: string;
        customerComment: string;
        deliveryMethodInfo: DeliveryMethod;
        droppointId: string;
        deliveryInstructions: string;
        items: OrderLineInfo[];
        packages: PackageInfo[];
        collectionOrderItemId: string;
        collectionOrderItemSku: string;
        collectionOrderQty: string;
    }

}